/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { SWMC_DOMAIN_NAME, CELLIGENCE_DOMAIN_NAME, CDN_URL_RESOURCE } from "../Utils";

export default function MetaTags({ eventCreatedUnderDomain, metaTagsData }) {
    const [favicon, setFavicon] = useState("");
    const [logoPng, setLogoPng] = useState("");

    useEffect(() => {
        if (eventCreatedUnderDomain === SWMC_DOMAIN_NAME) {
            setFavicon(CDN_URL_RESOURCE + "common/images/logo/favicon.ico");
            setLogoPng(CDN_URL_RESOURCE + "common/images/logo/logo.png");
        } else if (eventCreatedUnderDomain === CELLIGENCE_DOMAIN_NAME) {
            setFavicon(CDN_URL_RESOURCE + "common/images/logo/faviconcelligence.ico");
            setLogoPng(CDN_URL_RESOURCE + "common/images/logo/celligence_logo.png");
        } else {
            setFavicon(CDN_URL_RESOURCE + "common/images/logo/angelai_favicon.ico");
            setLogoPng(CDN_URL_RESOURCE + "common/images/logo/angelai_logo.png");
        }
    }, [eventCreatedUnderDomain]);

    return (
        <Helmet>
            <link rel="canonical" href={metaTagsData.url} />
            <link rel="icon" href={favicon} />
            <link rel="apple-touch-icon" href={logoPng}></link>
            <title>{metaTagsData.title}</title>
            <meta name="description" content={metaTagsData.description} />
            <meta name="keywords" content={metaTagsData.keywords} />
            <meta property="og:url" content={metaTagsData.url} />
            <meta property="og:type" content="website" />
            <meta name="title" property="og:title" content={metaTagsData.title} />
            <meta name="image" property="og:image" content={metaTagsData.thumbnail || metaTagsData.image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="600" />
            <meta name="description" property="og:description" content={metaTagsData.description} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:url" content={metaTagsData.url} />
            <meta name="twitter:title" content={metaTagsData.title} />
            <meta name="twitter:description" content={metaTagsData.description} />
            <meta name="twitter:image" content={metaTagsData.thumbnail || metaTagsData.image} />
        </Helmet>
    );
};